import * as Session from './Session';
import * as Actions from './Actions';

export const Dispatcher = (node: React.Component, EV: string, payload: any) => {

    //switch (EV) {
    //    case 'SYS.heartbeat':
    //        return window.tradeflow_binddata(processor.type, node, processor.delegate);
    //    case 'DATA.newalert':
    //        return window.tradeflow_binddata(processor.type, node, processor.delegate);
    //    case 'DATA.updateinstrument':
    //        return window.tradeflow_binddata('DATA.updateinstrument_' + processor.fiid, node, processor.delegate);
    //    case 'DATA.updatemyorders':
    //        return window.tradeflow_binddata('DATA.updatemyorders', node, processor.delegate);
    //    case 'DATA.updatemydeals':
    //        return window.tradeflow_binddata('DATA.updatemydeals', node, processor.delegate);
    //    default:
    //        const exhaustiveCheck: never = processor;
    //}

    return {};
};


export const LoginDispatcher = (node: React.Component, action: Session.LoginAction) => {
    node.setState(function (state: Session.LoginState, props) {
        return Session.loginStateForwarder(state, action);
    });

    return {};
    //this.setState({ ...this.state, ...stateforwarder(this.state, action) });
}

export const OrderDispatcher = (node: React.Component, action: Actions.OrderAction) => {
    node.setState(function (state: Actions.OrderState, props) {
        return Actions.orderStateForwarder(state, action);
    });

    return {};
}

export const FilterSettingsDispatcher = (node: React.Component, action: Actions.FilterSettingsAction) => {
    node.setState(function (state: Actions.OrderState, props) {
        return Actions.filterSettingsStateForwarder(state, action);
    });

    return {};
}

export const ContragentLimitsDispatcher = (node: React.Component, action: Actions.ContragentLimitsAction) => {
    node.setState(function (state: Actions.OrderState, props) {
        return Actions.ContragentLimitsStateForwarder(state, action);
    });

    return {};
}


